export default "__VITE_ASSET__NB0YPDj6__"